/** The novelty analysis as the server owns it: the gate, the run, and the served result. */

import type {
  AdmissionRuling,
  AdmissionRulingRequest,
  AnalysisResponse,
  AnalysisStateResponse,
  RunGateResponse,
  RunRequest,
} from "@patent-studio/api-types";
import { get, post, put } from "@/services/api-client";

export function runGate(taskId: string): Promise<RunGateResponse> {
  return get<RunGateResponse>(`/tasks/${taskId}/novelty/gate`);
}

/**
 * Start the run as a job. Narrowed to the positions named when any are, which
 * waives the confirmed condition for them alone; every position otherwise.
 * The server answers 409 while the gate is not ready or a run is in flight.
 */
export function startRun(
  taskId: string,
  positionIds?: string[],
): Promise<AnalysisStateResponse> {
  const body: RunRequest = { position_ids: positionIds ?? null };
  return post<AnalysisStateResponse>(`/tasks/${taskId}/novelty/run`, body);
}

/**
 * Carry the analysis into Claim Strategy: the one server act behind Continue to
 * Claim Strategy. It answers the gate back, and 409 while any position is not
 * settled.
 */
export function commitNovelty(taskId: string): Promise<RunGateResponse> {
  return post<RunGateResponse>(`/tasks/${taskId}/novelty/commit`, {});
}

export function readAnalysis(taskId: string): Promise<AnalysisResponse> {
  return get<AnalysisResponse>(`/tasks/${taskId}/novelty/analysis`);
}

/**
 * Accept or strike one entry of what the disclosure admits is known. The
 * server reads the analysis again with the entry or without it and answers the
 * analysis as it then reads.
 */
export function ruleAdmission(
  taskId: string,
  entryId: string,
  ruling: AdmissionRuling,
): Promise<AnalysisResponse> {
  const body: AdmissionRulingRequest = { ruling };
  return put<AnalysisResponse>(
    `/tasks/${taskId}/novelty/admitted/${entryId}`,
    body,
  );
}
